<template>
  <div class="winning-clue">
		<template v-if="isList">
			<van-search 
				v-model="value" 
				placeholder="请输入名称进行搜索" 
			/>
			<refresh-list 
				style="margin-top: 2px;"
				:list='list'
				@onLoad="onLoad" 
				@onRefresh="init"
				ref="refreshList"
			>
				<div class="content">
          <div class="item-box" v-for="(item,index) in list" :key="index" @click="jumpDetail(item)">
            <div class="img-box">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="item.cover"
              />
            </div>
            <p>{{item.title}}</p>
          </div>
        </div>
			</refresh-list>
		</template>
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
export default {
	components: {
		refreshList
	},
	data() {
		return {
			value: "",
			list:[],
			pageNum: 1,
			pageSize: 20,
			firstInto: true,
			isList: false
		}
	},
	watch: {
    value: {
      handler(value) {
        this.init() 
      }
    }
  },
	mounted() {
    this.init();
  },
	methods: {
		onLoad() {
      this.queryLotteryRecordPageList();
    },
		init() {
      this.pageNum = 1;
      this.list = [];
      this.queryLotteryRecordPageList();
    },
		queryLotteryRecordPageList() {
			let parmes = {
				filterData: {
					searchKey: this.value
				},
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
			this.$api.help.queryDocuments(parmes).then(res => {
				if (res.code == 200) {
					if (this.firstInto) {
						this.isList = res.data.list.length ? true : false
						this.firstInto = false
					}
					this.list.push(...res.data.list);
					this.pageNum = res.data.pageNum + 1;
					if(this.isList) this.$refs["refreshList"].complete(res.data);
				} else {
					if(this.isList) this.$refs["refreshList"].onFinish();
				}
			})
			.catch((err) => {
				this.$refs["refreshList"].onFinish();
			});
		},
    async jumpDetail(item) {
      item.searchKey = this.value
			let parmes = {
				path: '/help-video',
				query: item
			}
			if (item.type == 'mp4') {
			 	const {width, height} = await	this.getVideoWidth(item.content)
				parmes.path = '/help-video'
				width > height ? item.screenMode = true : item.screenMode = false
			}else {
				parmes.path = '/help-file'
			}
			this.$router.push(parmes)
    },
		getVideoWidth(fileUrl) {
      return new Promise((resolve, reject) => {
        let url = fileUrl;
        const newvideoUrl = url;
        const videoObj = document.createElement("video");
        videoObj.preload = "metadata";
        videoObj.src = newvideoUrl;
        videoObj.onloadedmetadata = function (evt) {
          URL.revokeObjectURL(newvideoUrl);
          let videoTime = videoObj.duration; // 获取视频的时长
          let width = videoObj.videoWidth; //获取视频的宽
          let height = videoObj.videoHeight; //获取视频的高
          resolve({ width, height });
        };
      });
    },

	},
	filters: {
		status(type) {
			let map = {
				1: '待兑奖',
				2: '已兑换'
			}
			return map[type]
		}	
	}
}
</script>

<style lang="stylus" scoped>
	.winning-clue {
    .content {
      display: flex;
      flex-flow: wrap;
			justify-content: space-between;
      .item-box {
        width: 164px;
        padding: 10px;
        height: 140px;
        background: #fff;
        margin-bottom: 8px;
        .img-box {
          width: 100%;
          height: 100px;
          border-radius: 6px;
          background: #ccc;
          img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }
        }
        p {
          width: 100%;
          overflow:hidden;
          text-overflow:ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical
        }
      }
      // .item-box:nth-child(odd) {
      //   margin-right: 5px;
      // }
    }
		
	}
</style>